import React from 'react';
import {injectIntl, intlShape, FormattedDate, FormattedTime} from 'react-intl';


// Renders dateToRender as a date, if it is not the same date as today (No matter the time)
// Renders the time of dateToRender (hours and minutes), if dateToRender has
// the same date as today 
// dateToRender: date and time as a string.
const FormattedDayOrTime = ({dateToRender, includeTime=false, intl}) => {
    let today = new Date().setHours(0,0,0,0);
    let date  = new Date(dateToRender).setHours(0,0,0,0);
    let dateIsToday = (date == today);
    if( dateIsToday ){
      return(<FormattedTime value={dateToRender} hour12={true} />);
    }
    else{
      if( includeTime ){
        return(
          <FormattedDate value={dateToRender} hour12={true} day='numeric' month='numeric' year='numeric' hour='numeric' minute='numeric' />
        );
      }
      return(
        <FormattedDate value={dateToRender} />
      );
    }

}

export default injectIntl(FormattedDayOrTime);